import { CultureInfo } from '../culture-info.model';
import { CultureInfoUrAran } from './ur-Aran';

/**
 * @ignore
 */
export const CultureInfoUrAranIN: CultureInfo = {
  name: 'ur-Aran-IN',
  displayName: 'اردو (نستعلیق،بھارت)',
  iso3LanguageCode: 'urd',
  iso2LanguageCode: 'ur',
  ietfLanguageTag: 'ur-Aran-IN',
  parent: CultureInfoUrAran
};
